export const TABLE_KEYS = Object.freeze({
  adminJobs: 'adminJobs',
  adminUsers: 'adminUsers',
  adminProperties: 'adminProperties',
  guestRequestOrders: 'guestRequestOrders',
  irdOrders: 'irdOrders',
});
